export default (apiData, checkType = "free") => {
  if (typeof apiData === "string") {
    return true;
  }

  if (Array.isArray(apiData) && apiData.length === 1) {
    const firstItem = apiData[0];
    if (firstItem && typeof firstItem === "object" && Object.keys(firstItem).length === 1 && firstItem.id) {
      return true;
    }
  }

  if (apiData && typeof apiData === "object" && !Array.isArray(apiData)) {
    const keys = Object.keys(apiData);
    if (keys.length <= 2 && apiData.id && !apiData.followers && !apiData.posts) {
      if (checkType === "free" && !apiData.engagementMean) {
        return true;
      }
      if (checkType === "paid" && !apiData.audienceAnalysis) {
        return true;
      }
    }
  }

  return false;
};

